import React, { useEffect, useState } from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

const DarkModeToggle = ({ className = '' }) => {
  const [isDark, setIsDark] = useState(() => {
    // Initialize from localStorage
    try {
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        return JSON.parse(saved);
      }
      // Fallback to checking document class
      return document.documentElement.classList.contains('dark');
    } catch (error) {
      console.error('Error reading theme from localStorage:', error);
      return document.documentElement.classList.contains('dark');
    }
  });

  useEffect(() => {
    // Apply theme to document on mount
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggleDarkMode = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    
    // Update document class
    if (newIsDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    
    // Save to localStorage
    try {
      localStorage.setItem('darkMode', JSON.stringify(newIsDark));
    } catch (error) {
      console.error('Error saving theme to localStorage:', error);
    }
  };

  return (
    <div className={`flex items-center ${className}`}>
      <button
        onClick={toggleDarkMode}
        className="relative inline-flex h-10 w-20 items-center rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-300 focus:outline-none"
      >
        {/* Track */}
        <span
          className={`absolute inset-0 rounded-full ${
            isDark ? 'bg-gray-700' : 'bg-gray-200'
          } transition-colors duration-300`}
        />

        {/* Background Icons */}
        <span className="pointer-events-none absolute inset-0 flex items-center justify-between px-2 z-0">
          <SunIcon className={`h-4 w-4 ${isDark ? 'text-gray-500' : 'text-yellow-400'}`} />
          <MoonIcon className={`h-4 w-4 ${isDark ? 'text-blue-300' : 'text-gray-400'}`} />
        </span>

        {/* Thumb with Icon */}
        <span
          className={`relative z-10 h-8 w-8 transform rounded-full bg-white shadow-md ring-0 transition-transform duration-300 ${
            isDark ? 'translate-x-11' : 'translate-x-1'
          }`}
        >
          {/* Moving Icon */}
          <span className="absolute inset-0 flex items-center justify-center transition-opacity">
            {isDark ? (
              <MoonIcon className="h-4 w-4 text-gray-700" />
            ) : (
              <SunIcon className="h-4 w-4 text-yellow-500" />
            )}
          </span>
        </span>
      </button>
    </div>
  );
};

export default DarkModeToggle; 